<template>
    <div>
        <h2 class="col-lg-12 text-center mb-3">{{ $t('edit') }}</h2>
        <ExperiencesForm :baseExperience="experience" :baseExperienceName="name" :loading="loading" @submit-requested="submitRequested"></ExperiencesForm>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import ExperiencesForm from '../forms/FormExperiences.vue'
import router from '@/router';

export default {
    data() {
        return {
            experience: null,
            name: this.$route.params.name,
            loading: true
        }
    },
    components: { ExperiencesForm },
    computed:
    {
        ...mapState('experiences', ['getExperienceByIdOutput']),
    },
    methods: {
        ...mapActions('experiences', ['getExperienceById']),
        ...mapActions('experiences', ['putExperience']),
        submitRequested(experience) {
            this.putExperience(experience);
        },
    },
    mounted: function () {
        if (!this.$route.query.id) {
            router.push({ name: 'ExperiencesList' });
        }

        this.getExperienceById(this.$route.query.id);
    },
    watch:
    {
        getExperienceByIdOutput: function(experienceOutput)
        {
            if(!experienceOutput && !experienceOutput.data)
            {
                router.push({ name: 'ExperiencesList' });
            }
            else
            {
                this.experience = experienceOutput.data;
                this.loading = false;
            }
        }
    }
}
</script>
